import { IChildrenProps } from "../types/IChildrenProps";
import { useState } from 'react';
import { useLoader } from '../hooks/useLoader';
import LoadingSpinner from '../components/Loading/LoadingSpinner';
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";

const MainLayout = (props: IChildrenProps) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const loader = useLoader();

    return (
        <>
            { loader?.isLoading ? <LoadingSpinner /> : <></> }
            <div className="dark:bg-boxdark-2 dark:text-bodydark">
                <div className="flex h-screen overflow-hidden">
                    <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                    <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
                        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                        <main>
                            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                                { props.children }
                            </div>
                        </main>
                    </div>
                </div>                
            </div>
        </>
    )
}

export default MainLayout;